import { QRFC } from "./QRFC";

export class QTestSharepointConnectionRFC extends QRFC {
  constructor() {
    super();
  }

  InitTestSharepointConnectionRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  GetCallName() {
    return "qmongorfc";
  }

  SetParams(orgName, userName, creds) {
    this.AddParameter("data", JSON.stringify(creds));
    this.AddParameter("mode", "testSharepointConnection");
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
  }

  DoTransactionComplete(response, callBackObj) {
    let parsed;
    try {
      parsed = JSON.parse(response);
    } catch (e) {
      parsed = { success: false, error: "parse_failed" };
    }
    if (callBackObj) callBackObj.HandleResponse(parsed);
  }
}
